<template>
  <div class="r-text-disclaimer">
    <div>החישוב המוצג הוא להמחשה בלבד</div>
    <div>לפי 4% ריבית (תשואה) משוערת בניכוי דמי ניהול</div>
    <div style="margin-top: 12px">
      האמור אינו מהווה ייעוץ ו/או שיווק פנסיוני ו/או תחליף לייעוץ/שיווק פנסיוני המתחשב
      בנתונים ובצרכים של כל אדם ואין באמור משום הבטחת תשואה או רווח. דמי הניהול הינם
      {{ COMMISSION_IN_PERCENTAGE }}% לשנה קלנדרית מהצבירה. מבית מיטב ואיילון ביטוח. החברה המנהלת מיטב גמל
      ופנסיה בע"מ.
    </div>
  </div>
</template>

<script>
import { COMMISSION_IN_PERCENTAGE } from '@/constants/meitav-dash/open-fund';

export default {
  name: 'Disclaimer',
  computed: {
    COMMISSION_IN_PERCENTAGE() {
      return COMMISSION_IN_PERCENTAGE;
    },
  },
};
</script>
